function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u7F16\u7EC4 26");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u65B0\\u6837\\u5F0F-\\u641C\\u7D22",
  transform: "translate(-451.000000, -351.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-6",
  transform: "translate(262.000000, 92.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-20",
  transform: "translate(190.000000, 260.000000)"
}, React.createElement("g", {
  id: "\\u7F16\\u7EC4-26"
}, React.createElement("rect", {
  id: "\\u77E9\\u5F62",
  stroke: "#AACCFF",
  fill: "#E6F0FF",
  x: 0,
  y: 0,
  width: 32,
  height: 16,
  rx: 2
}), React.createElement("path", {
  d: "M11.632,2.22 L12.52,2.22 L12.52,5.844 C13.516,6.576 14.524,7.404 15.556,8.328 L15.028,9.12 C14.044,8.136 13.216,7.356 12.52,6.804 L12.52,13.188 L11.632,13.188 L11.632,2.22 Z M6.784,6.984 C7.456,7.344 8.068,7.764 8.62,8.244 C9.172,7.188 9.544,6.012 9.724,4.728 L7.348,4.728 C6.772,6.096 5.992,7.212 5.032,8.1 L4.444,7.368 C5.812,6.096 6.748,4.368 7.228,2.208 L8.092,2.352 C7.972,2.892 7.828,3.408 7.66,3.9 L10.576,3.9 L10.576,4.656 C10.168,8.292 8.416,11.04 5.296,12.9 L4.708,12.168 C6.208,11.304 7.384,10.224 8.224,8.928 C7.6,8.4 6.964,7.968 6.328,7.656 L6.784,6.984 Z M18.256,4.644 C18.544,5.196 18.82,5.868 19.06,6.66 L20.32,6.66 C20.668,6 20.968,5.292 21.208,4.548 L22.012,4.824 C21.76,5.508 21.484,6.12 21.172,6.66 L22.624,6.66 L22.624,7.5 L16.612,7.5 L16.612,6.66 L18.232,6.66 C18.016,6.036 17.764,5.46 17.464,4.932 L18.256,4.644 Z M23.176,2.7 L27.112,2.7 L27.112,3.348 C26.74,4.608 26.344,5.784 25.912,6.864 C26.812,7.992 27.268,8.928 27.28,9.648 C27.28,10.392 27.124,10.908 26.812,11.196 C26.476,11.484 25.816,11.64 24.832,11.64 L24.556,10.728 C24.892,10.752 25.168,10.776 25.396,10.776 C25.828,10.752 26.104,10.668 26.224,10.524 C26.344,10.368 26.404,10.08 26.416,9.648 C26.404,8.94 25.924,8.016 24.988,6.864 C25.384,5.916 25.78,4.788 26.164,3.492 L24.016,3.492 L24.016,13.176 L23.176,13.176 L23.176,2.7 Z M16.84,3.36 L19.252,3.36 C19.108,2.964 18.964,2.604 18.808,2.28 L19.696,2.124 C19.828,2.484 19.96,2.904 20.092,3.36 L22.54,3.36 L22.54,4.2 L16.84,4.2 L16.84,3.36 Z M22.072,8.592 L22.072,13.116 L21.22,13.116 L21.22,12.444 L18.148,12.444 L18.148,13.116 L17.296,13.116 L17.296,8.592 L22.072,8.592 Z M18.148,11.628 L21.22,11.628 L21.22,9.408 L18.148,9.408 L18.148,11.628 Z",
  id: "\\u5916\\u90E8",
  fill: "#1673FF",
  fillRule: "nonzero"
}))))));

var SvgExternal = function SvgExternal(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "34px",
    height: "18px",
    viewBox: "0 0 34 18",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgExternal, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/external.ccefb5f4.svg";
export { ForwardRef as ReactComponent };